const Permissions = {
  backend: {
    name: {
      en: 'Backend',
      km: 'ផ្ទាំងក្រោយ'
    },
    manage: 'manage-backend',
    dashboard: {
      name: {
        en: 'Dashboard',
        km: 'ទំព័រដើម'
      },
      manage: 'manage-dashboard',
      show: 'show-dashboard',
      viewApplicantChart: 'view-applicant-chart',
      viewDraftChart: 'view-draft-chart',
      viewNewClientChart: 'view-new-client-chart',
      viewOldClientChart: 'view-old-client-chart',
      viewLoanChart: 'view-loan-chart',
      viewRejectChart: 'view-reject-chart',
      viewApprovalRateChart: 'view-approval-rate-chart',
      viewInvestorChart: 'view-investor-chart',
      viewApplicantCancellationChart: 'view-applicant-cancellation-chart',
      viewLoanCancellationChart: 'view-loan-cancellation-chart',
      viewCompareTable: 'view-compare-table'
    },
    applicant: {
      name: {
        en: 'Applicant',
        km: 'អ្នកស្នើសុំដែលរង់ចាំពិនិត្យ'
      },
      manage: 'manage-applicant',
      list: 'list-applicant',
      export: 'export-applicant',
      assignLoanOfficer: 'assign-loan-officer-applicant',
      edit: 'edit-applicant',
      show: 'show-applicant',
      approve: 'approve-applicant',
      cancelLoan: 'cancel-loan-applicant',
      rejectApplicant: 'reject-applicant',
      delete: 'delete-applicant',
      filterColumnTable: 'filter-column-applicant-table'
    },
    draft: {
      name: {
        en: 'Draft',
        km: 'អ្នកស្នើសុំដែលព្រាង'
      },
      manage: 'manage-draft',
      list: 'list-draft',
      export: 'export-draft',
      assignLoanOfficer: 'assign-loan-officer-draft',
      edit: 'edit-draft',
      show: 'move-draft',
      cancelLoan: 'cancel-loan-draft',
      move: 'move-draft',
      delete: 'delete-draft',
      filterColumnTable: 'filter-column-draft-table'
    },
    client: {
      name: {
        en: 'Client',
        km: 'អ្នកកម្ចី'
      },
      manage: 'manage-client',
      list: 'list-client',
      export: 'export-client',
      assignLoanOfficer: 'assign-loan-officer-client',
      edit: 'edit-client',
      show: 'show-client',
      delete: 'delete-client',
      syncAllLoan: 'sync-all-loan',
      syncLoan: 'sync-loan',
      changeBorrowerId: 'change-borrower-id',
      filterColumnTable: 'filter-column-client-table',
      uploadLoanAndCollectionOfficer: 'upload-loan-and-collection-officer'
    },
    cancelled: {
      name: {
        en: 'Cancelled',
        km: 'សំន្នើសុំដែលបោះបង់'
      },
      manage: 'manage-cancelled',
      list: 'list-cancelled',
      export: 'export-cancelled',
      assignLoanOfficer: 'assign-loan-officer-cancelled',
      listReason: 'list-reason-cancelled',
      edit: 'edit-cancelled',
      move: 'move-cancelled',
      show: 'show-cancelled'
    },
    rejected: {
      name: {
        en: 'Rejected',
        km: 'សំន្នើសុំដែលបានបដិសេធ'
      },
      manage: 'manage-rejected',
      list: 'list-rejected',
      export: 'export-rejected',
      show: 'show-rejected',
      assignLoanOfficer: 'assign-loan-officer-rejected'
    },
    trashed: {
      name: {
        en: 'Trashed',
        km: 'សំន្នើសុំដែលបានលុប'
      },
      manage: 'manage-trashed',
      list: 'list-trashed',
      show: 'show-trashed',
      export: 'export-trashed',
      comment: 'comment-trashed',
      assignLoanOfficer: 'assign-loan-officer-trashed'
    },
    profileScoring: {
      name: {
        en: 'Profile Scoring',
        km: 'វាយតម្លៃពិន្ទុ'
      },
      manage: 'manage-profile-scoring',
      list: 'list-profile-scoring',
      edit: 'edit-profile-scoring',
      calculate: 'calculate-profile-scoring',
      viewStatisticProfileScoring: 'view-statistic-profile-scoring'
    },
    criteriaScore: {
      name: {
        en: 'Criteria Score',
        km: 'ពិន្ទុលក្ខណៈវិនិច្ឆ័យ'
      },
      manage: 'manage-criteria-score',
      list: 'list-criteria-score',
      edit: 'edit-criteria-score',
      delete: 'delete-criteria-score',
      store: 'store-criteria-score'
    },
    comment: {
      name: {
        en: 'Comment',
        km: 'ផ្តល់មត្តិយោបល់'
      },
      manage: 'manage-comment',
      list: 'list-comment',
      show: 'show-comment',
      store: 'store-comment',
      edit: 'edit-comment',
      delete: 'delete-comment',
      deleteFilesComment: 'delete-files-comment'
    },
    referral: {
      name: {
        en: 'Referral',
        km: 'ណែនាំ'
      },
      manage: 'manage-referral',
      list: 'list-referral',
      show: 'show-referral',
      store: 'store-referral',
      edit: 'edit-referral'
    },
    invest: {
      name: {
        en: 'Invest',
        km: 'វិនិយោគ'
      },
      manage: 'manage-invest',
      list: 'list-invest',
      show: 'show-invest',
      store: 'store-invest',
      edit: 'edit-invest'
    },
    loan: {
      name: {
        en: 'Loan',
        km: 'កម្ចី'
      },
      manage: 'manage-loan',
      payDay: {
        name: {
          en: 'Payday Loan',
          km: 'កម្ចីគិតជាថ្ងៃ'
        },
        manage: 'manage-payday-loan',
        list: 'list-payday-loan',
        show: 'show-payday-loan',
        edit: 'edit-payday-loan',
        refund: 'refund-payday-loan'
      },
      personal: {
        name: {
          en: 'Personal Loan',
          km: 'កម្ចីគិតជាខែ'
        },
        manage: 'manage-personal-loan',
        list: 'list-personal-loan',
        show: 'show-personal-loan',
        edit: 'edit-personal-loan',
        refund: 'refund-personal-loan'
      },
      pawn: {
        name: {
          en: 'Pawn Loan',
          km: 'កម្ចីបញ្ជាំ'
        },
        manage: 'manage-pawn-loan',
        list: 'list-pawn-loan',
        show: 'show-pawn-loan',
        edit: 'edit-pawn-loan',
        refund: 'refund-pawn-loan'
      },
      purchasing: {
        name: {
          en: 'Purchasing Loan',
          km: 'កម្ចីបង់រលោះ'
        },
        manage: 'manage-purchasing-loan',
        list: 'list-purchasing-loan',
        show: 'show-purchasing-loan',
        edit: 'edit-purchasing-loan',
        refund: 'refund-purchasing-loan'
      }
    },
    interestRate: {
      name: {
        en: 'Interest Rate',
        km: 'អត្រាការប្រាក់'
      },
      manage: 'manage-interest-rate',
      payDay: {
        name: {
          en: 'Payday Interest Rate',
          km: 'អាត្រាការប្រាក់គិតជាថ្ងៃ'
        },
        manage: 'manage-payday-interest-rate',
        list: 'list-payday-interest-rate',
        show: 'show-payday-interest-rate',
        store: 'store-payday-interest-rate',
        edit: 'edit-payday-interest-rate',
        delete: 'delete-payday-interest-rate'
      },
      personal: {
        name: {
          en: 'Personal Interest Rate',
          km: 'អាត្រាកាប្រាក់គិតជាខែ'
        },
        manage: 'manage-personal-interest-rate',
        list: 'list-personal-interest-rate',
        show: 'show-personal-interest-rate',
        store: 'store-personal-interest-rate',
        edit: 'edit-personal-interest-rate',
        delete: 'delete-personal-interest-rate'
      },
      pawn: {
        name: {
          en: 'Pawn Interest Rate',
          km: 'បញ្ជីអត្រាការប្រាក់បញ្ចាំ'
        },
        manage: 'manage-pawn-interest-rate',
        list: 'list-pawn-interest-rate',
        show: 'show-pawn-interest-rate',
        store: 'store-pawn-interest-rate',
        edit: 'edit-pawn-interest-rate',
        delete: 'delete-pawn-interest-rate'
      },
      purchasing: {
        name: {
          en: 'Purchasing Interest Rate',
          km: 'បញ្ជីអត្រាការប្រាក់ទិញទំនិញ'
        },
        manage: 'manage-purchasing-interest-rate',
        list: 'list-purchasing-interest-rate',
        show: 'show-purchasing-interest-rate',
        store: 'store-purchasing-interest-rate',
        edit: 'edit-purchasing-interest-rate',
        delete: 'delete-purchasing-interest-rate'
      }
    },
    setting: {
      name: {
        en: 'Setting',
        km: 'ការកំណត់'
      },
      manage: 'manage-setting',
      membership: {
        name: {
          en: 'Membership',
          km: 'សមាជិក'
        },
        manage: 'manage-membership',
        list: 'list-membership',
        show: 'show-membership',
        store: 'store-membership',
        edit: 'edit-membership',
        delete: 'delete-membership'
      },
      background: {
        name: {
          en: 'Background',
          km: 'ផ្ទាំងក្រោយ'
        },
        manage: 'manage-background',
        list: 'list-background',
        show: 'show-background',
        store: 'store-background',
        edit: 'edit-background',
        delete: 'delete-background',
        toggle: 'toggle-background'
      },
      whyUsImage: {
        name: {
          en: 'Why Us Image',
          km: 'ផ្ទាំងរូបភាព Why Us'
        },
        manage: 'manage-why-us-image',
        list: 'list-why-us-image',
        show: 'show-why-us-image',
        store: 'store-why-us-image',
        edit: 'edit-why-us-image',
        delete: 'delete-why-us-image',
        toggle: 'toggle-why-us-image'
      },
      assignLoanOfficer: {
        name: {
          en: 'Assign Loan Officer (New Applicant)',
          km: 'ចាត់តាំងមន្រ្តីប្រាក់កម្ចី (អ្នកកម្ចីថ្មី)'
        },
        manage: 'manage-assign-loan-officer',
        list: 'list-assign-loan-officer',
        edit: 'edit-assign-loan-officer',
        show: 'show-assign-loan-officer',
        store: 'store-assign-loan-officer',
        delete: 'delete-assign-loan-officer'
      },
      assignLoanOfficerOldClient: {
        name: {
          en: 'Assign Loan Officer (Old Client)',
          km: 'ចាត់តាំងមន្រ្តីប្រាក់កម្ចី (អតិថិជនចាស់)'
        },
        manage: 'manage-assign-loan-officer-old-client',
        list: 'list-assign-loan-officer-old-client',
        edit: 'edit-assign-loan-officer-old-client',
        store: 'store-assign-loan-officer-old-client',
        show: 'show-assign-loan-officer-old-client',
        delete: 'delete-assign-loan-officer-old-client'
      },
      reason: {
        name: {
          en: 'Reason',
          km: 'ហេតុផល'
        },
        manage: 'manage-reason',
        list: 'list-reason',
        store: 'store-reason',
        edit: 'edit-reason',
        show: 'show-reason',
        delete: 'delete-reason'
      }
    },
    administration: {
      name: {
        en: 'Administration',
        km: 'រដ្ឋបាល'
      },
      manage: 'manage-administration',
      user: {
        name: {
          en: 'User',
          km: 'អ្នកប្រើប្រាស់'
        },
        manage: 'manage-user',
        list: 'list-user',
        show: 'show-user',
        store: 'store-user',
        edit: 'edit-user',
        changePassword: 'change-user-password'
      },
      role: {
        name: {
          en: 'Role',
          km: 'តួនាទី'
        },
        manage: 'manage-role',
        list: 'list-role',
        show: 'show-role',
        store: 'store-role',
        edit: 'edit-role',
        delete: 'delete-role'
      },
      permission: {
        name: {
          en: 'Permission',
          km: 'សិទ្ធិ'
        },
        manage: 'manage-permission',
        list: 'list-permission'
      }
    }
  }
}

export const dependencies = {
  'show-user': [
    'list-user'
  ],
  'edit-user': [
    'show-user'
  ],
  'change-user-password': [
    'show-user'
  ],
  'delete-user': [
    'show-user'
  ],
  'edit-role': [
    'show-role'
  ]
}

export const naming = {
  manage: {
    en: 'Manage $$',
    km: 'គ្រប់គ្រង$$'
  },
  list: {
    en: 'List $$',
    km: 'មើលបញ្ជី$$'
  },
  show: {
    en: 'View $$ Detail',
    km: 'បង្ហាញព័ត៌មានលម្អិត$$'
  },
  store: {
    en: 'Store $$',
    km: 'រក្សាទិន្នន័យ$$'
  },
  edit: {
    en: 'Edit $$',
    km: 'កែសម្រួលទិន្នន័យ$$'
  },
  delete: {
    en: 'Delete $$',
    km: 'លុបទិន្នន័យ$$'
  },
  changePassword: {
    en: 'Change $$\'s Password',
    km: 'កែពាក្យសម្ងាត់របស់$$'
  },
  toggle: {
    en: 'Toggle $$',
    km: 'បិទ ឬ បើក $$'
  },
  showHistory: {
    en: 'Show $$\'s History',
    km: 'បង្ហាញប្រវត្តិរបស់$$'
  },
  search: {
    en: 'Search $$',
    km: 'ស្វែងរក$$'
  },
  makeVisibility: {
    en: 'Change $$ Visibility',
    km: 'កែប្រែភាពមើលឃើញនៃ$$'
  },
  sendEmail: {
    en: 'Send E-mail about $$',
    km: 'ផ្ញើអ៊ីមែលអំពី$$'
  },
  activate: {
    en: 'Activate $$',
    km: 'បើកឲ្យដំណើរការ$$'
  },
  archive: {
    en: 'Archive $$',
    km: 'ទុក$$នៅមួយឡែក'
  },
  unarchive: {
    en: 'Unarchive $$',
    km: 'យក$$ទៅទុកវិញ'
  },
  add: {
    en: 'Add $$',
    km: 'បន្ថែម$$'
  },
  remove: {
    en: 'Remove $$',
    km: 'ដកចេញ$$'
  },
  undraft: {
    en: 'Undraft $$',
    km: 'រក្សាទុក$$ពិតប្រាកដ'
  },
  process: {
    en: 'Process $$',
    km: 'ដំណើរការ$$'
  },
  viewApplicantChart: {
    en: 'View applicant chart',
    km: 'មើលក្រាហ្វិចអ្នកស្នើខ្ចី'
  },
  viewDraftChart: {
    en: 'Show draft chart',
    km: 'មើលក្រាហ្វិចអ្នកស្នើសុំព្រាង'
  },
  viewNewClientChart: {
    en: 'View new client chart',
    km: 'មើលក្រាហ្វិចអតិថិជនថ្មី'
  },
  viewOldClientChart: {
    en: 'View old client chart',
    km: 'មើលក្រាហ្វិចអតិថិជនចាស់'
  },
  viewLoanChart: {
    en: 'View loan chart',
    km: 'មើលក្រាហ្វិចកម្ចី'
  },
  viewRejectChart: {
    en: 'View reject chart',
    km: 'មើលក្រាហ្វិចបដិសេធ'
  },
  viewApprovalRateChart: {
    en: 'View approval rate chart',
    km: 'មើលក្រាហ្វិចភាគរយយល់ព្រម'
  },
  viewInvestorChart: {
    en: 'View investor chart',
    km: 'មើលក្រាហ្វិចវិនិយោគ'
  },
  viewApplicantCancellationChart: {
    en: 'View applicant cancellation chart',
    km: 'មើលក្រាហ្វិចបោះបង់អ្នកស្នើសុំ'
  },
  viewLoanCancellationChart: {
    en: 'View loan cancellation chart',
    km: 'មើលក្រាហ្វិចបោះបង់កម្ជី'
  },
  viewCompareTable: {
    en: 'View compare table chart',
    km: 'មើលតារាងប្រៀបធៀប'
  },
  calculate: {
    en: 'Calculate $$',
    km: 'គណនា$$'
  },
  export: {
    en: 'Export $$',
    km: 'ទាញយកទិន្នន័យ$$'
  },
  comment: {
    en: 'Comment $$',
    km: 'ផ្តល់មតិ្តយោលបល់$$'
  },
  assignLoanOfficer: {
    en: 'Assign Loan Officer',
    km: 'ចាត់មន្ត្រីឥណទាន'
  },
  listReason: {
    en: 'List Reason',
    km: 'មើលបញ្ជីហេតុផល'
  },
  move: {
    en: 'Move applicant',
    km: 'ផ្លាស់ប្តូរទៅក្នុងបញ្ជីអ្នកស្នើ'
  },
  syncAllLoan: {
    en: 'Sync All Loan',
    km: 'Sync All Loan'
  },
  syncLoan: {
    en: 'Sync Loan',
    km: 'Sync Loan'
  },
  changeBorrowerId: {
    en: 'Change Borrower ID',
    km: 'ផ្លាស់ប្តូរអត្តលេខអតិថិជន'
  },
  cancelLoan: {
    en: 'Cancel Loan',
    km: 'បោះបង់ការស្នើសុំកម្ចី'
  },
  rejectApplicant: {
    en: 'Reject Applicant',
    km: 'បដិសេធការស្នើសុំកម្ចី'
  },
  approve: {
    en: 'Approve $$',
    km: 'អនុម័តសំន្នើ $$'
  },
  refund: {
    en: 'Refund',
    km: 'សងត្រលប់វិញ'
  },
  viewStatisticProfileScoring: {
    en: 'View Statistic Profile Scoring',
    km: 'មើលពិន្ទុប្រវត្តិរូបស្ថិតិ'
  },
  deleteFilesComment: {
    en: 'Delete files comment',
    km: 'លុបមតិយោបល់ឯកសារ'
  },
  filterColumnTable: {
    en: 'Filter columns table',
    km: 'ផ្លាស់ប្តូរព័ត៌មាននៃតារាង'
  },
  uploadLoanAndCollectionOfficer: {
    en: 'Upload loan and collection officer',
    km: 'ផ្ទុកឡើងមន្រ្តីទទួលបន្ទុកមើលនិងប្រមូលប្រាក់'
  }
}

export const generatePhpArray = () => {
  // Permissions convert to PHP array
  let php = ''
  let obj

  const tabs = (count = 1) => {
    let t = ''
    for (let i = 0; i < count; i++) {
      t += '\t'
    }
    return t
  }

  const recurse = (permission, tab = 1) => {
    const keyOrder = []
    for (const key in permission) {
      if (typeof permission[key] === 'object' && key !== 'name') {
        keyOrder.unshift(key)
      } else if (!['manage', 'name'].includes(key)) {
        keyOrder.push(key)
      }
    }
    for (const key of keyOrder) {
      if (typeof permission[key] === 'object' && key !== 'name') {
        obj = permission[key]
        php += tabs(tab) + '[\n'
        php += tabs(tab + 1) + `'name' => '${permission[key].manage}',\n`
        try {
          php += tabs(tab + 1) + `'display_name_en' => '${naming.manage.en.replace('$$', permission[key].name.en).replace('\'', '\\\'')}',\n`
          php += tabs(tab + 1) + `'display_name_km' => '${naming.manage.km.replace('$$', permission[key].name.km).replace('\'', '\\\'')}',\n`
        } catch (error) {
          console.log(naming)
        }
        php += tabs(tab + 1) + '\'children\' => [\n'
        recurse(permission[key], tab + 2)
        php += tabs(tab + 1) + '],\n'
        if (dependencies[permission[key].manage]) {
          php += tabs(tab + 1) + '\'dependencies\' => [\n'
          php += dependencies[permission[key].manage].map(dep => tabs(tab + 2) + `'${dep}',\n`)
          php += tabs(tab + 1) + '],\n'
        } else {
          php += tabs(tab + 1) + '\'dependencies\' => [],\n'
        }
        php += tabs(tab) + '],\n'
      } else if (!['manage', 'name'].includes(key)) {
        php += tabs(tab) + '[\n'
        php += tabs(tab + 1) + `'name' => '${obj[key]}',\n`
        try {
          php += tabs(tab + 1) + `'display_name_en' => '${naming[key].en.replace('$$', obj.name.en).replace('\'', '\\\'')}',\n`
          php += tabs(tab + 1) + `'display_name_km' => '${naming[key].km.replace('$$', obj.name.km).replace('\'', '\\\'')}',\n`
        } catch (error) {
          console.log(key)
        }
        php += tabs(tab + 1) + '\'children\' => [],\n'
        if (dependencies[obj[key]]) {
          php += tabs(tab + 1) + '\'dependencies\' => [\n'
          php += dependencies[obj[key]].map(dep => tabs(tab + 2) + `'${dep}',\n`)
          php += tabs(tab + 1) + '],\n'
        } else {
          php += tabs(tab + 1) + '\'dependencies\' => [],\n'
        }
        php += tabs(tab) + '],\n'
      }
    }
  }

  php += '$permissions = [\n'
  recurse(Permissions)
  php += '];'
  return php
}

export const copyPermission = () => {
  const textArea = document.createElement('textarea')
  textArea.value = generatePhpArray()
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  document.execCommand('copy')
  document.body.removeChild(textArea)
}

export default Permissions
